import { ToggleGroup } from '@interstate/components/ToggleGroup/ToggleGroup/ToggleGroup';
import { useBaseResidualInputProps, useResidualField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { CompositeValue } from '../../CompositeValue';
import { ScenarioManualEditMarker } from '../../ScenarioManualEditMarker';
import { ScenarioRow } from '../../ScenarioRow';

export const ResidualRow = () => {
    const inputProps = useBaseResidualInputProps();
    const { label, isReadOnlyForOpenGrid, overrideIndicatorProps, valueInputProps, unitToggleProps } = useResidualField({
        inputProps,
        fieldType: 'baseResidual',
        tab: DealTabs.SUMMARY
    });
    const inputId = useScenarioCellId('residual');

    return (
        <ScenarioRow rowKey="residual" label={label} inputId={inputId}>
            <CompositeValue control={!isReadOnlyForOpenGrid && <ToggleGroup {...unitToggleProps} toggleWidth="100%" />}>
                <ScenarioManualEditMarker {...overrideIndicatorProps}>
                    <NumericInput {...valueInputProps} inputPrefix={undefined} id={inputId} displayLabel={false} />
                </ScenarioManualEditMarker>
            </CompositeValue>
        </ScenarioRow>
    );
};
